export default __webpack_public_path__ + "static/media/319.d2dcbd67.gif";